/* Base translations · Related parties worksheet — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): rp. */
export const I18N_BASE_RELATED_PARTIES = {
  en: {
    // Batch C · Round C3 · W16 — Related-party transactions worksheet
    rp: {
      title: "Related-party transactions",
      subtitle: "Rows across all heads. Scan GL, confirm 211(a) parties, evaluate significance and disclosure.",
      addWorksheet: "Add related-party worksheet",
      partiesFrom211a: "Parties from 211(a)",
      no211aParties: "No parties listed in 211(a) yet — fill 211(a) first, or add rows manually below.",
      scanGl: "Scan GL",
      scanRunning: "GL scan running…",
      scanLastAt: "Last scan",
      addRow: "Add row",
      relatedParty: "Related party",
      relationship: "Relationship",
      transactionType: "Transaction type",
      amount: "Amount",
      fsHeadAccts: "FS head(s) / accounts",
      identifiedBy: "Identified by",
      idBy_211a: "211(a)", idBy_gl: "GL scan", idBy_minutes: "Minutes",
      idBy_confirmation: "Confirmation", idBy_other: "Other",
      normalCourse: "Normal course of business?",
      yeBalance: "Year-end balance",
      confirmationLink: "Confirmation link",
      disclosed: "Disclosed?",
      significant: "Significant?",
      outsideNormalCourse: "Outside normal course of business?",
      requiredEvidenceTitle: "Required evidence (significant + outside normal course)",
      req_contract: "Contract inspected",
      req_rationale: "Business rationale",
      req_terms: "Terms consistent with explanations",
      req_accounting: "Accounting appropriate",
      req_authorised: "Authorised and approved",
      armsLength: "Arm's length?",
      armsLengthEvidence: "Arm's-length evidence",
      newlyIdentified: "Newly identified (not in 211(a))",
      newlyChecklistTitle: "Newly-identified checklist",
      new_team_informed: "Team informed",
      new_management_asked: "Management asked for all transactions with this party",
      new_why_not: "Why not identified?",
      new_substantive: "Substantive procedures performed",
      new_risk_reassessed: "Risk reassessed",
      new_211a_updated: "211(a) updated",
      sendToMisstatements: "Send to misstatements",
      sentToMsOk: "Sent to misstatements.",
      communicateTcwg: "Communicated to those charged with governance",
      communicateTcwgDate: "Communication date",
      exception: "Exception",
      exceptionNote: "Exception note",
      conclusion: "Conclusion",
      preparer: "Preparer", reviewer: "Reviewer",
      markComplete: "Mark complete",
      hitsFound: "GL hits",
      scanRunning: "GL scan running…",
      scanResultOn: "GL scan result on {date}",
      noGlEntriesFor: "No GL entries found for {party}.",
      entriesFound: "{count} GL entries · Total {total}",
      viewSent: "View entry",
      reasons: {
        conclusion_missing: "Conclusion is required.",
        preparer_missing: "Preparer sign-off is required.",
        reviewer_missing: "Reviewer sign-off is required.",
        exception_note_required: "An exception needs a note.",
        significant_outside_normal_missing_evidence: "Significant + outside-normal-course rows need all five required evidence items.",
        arms_length_needs_evidence: "Rows claiming arm's length need supporting evidence.",
        newly_identified_incomplete: "Newly-identified rows need every checklist item completed.",
      },
    },
  },
  ar: {
    // Batch C · Round C3 · W16 — Related-party (AR)
    rp: {
      title: "معاملات الأطراف ذات العلاقة",
      subtitle: "الصفوف عبر جميع البنود. افحص دفتر الأستاذ، وأكِّد أطراف 211(a)، وقيِّم الأهمية والإفصاح.",
      addWorksheet: "إضافة ورقة أطراف ذات علاقة",
      partiesFrom211a: "الأطراف من 211(a)",
      no211aParties: "لا توجد أطراف في 211(a) بعد — املأ 211(a) أولاً أو أضف صفوفًا يدويًا أدناه.",
      scanGl: "فحص دفتر الأستاذ",
      scanRunning: "فحص دفتر الأستاذ جارٍ…",
      scanLastAt: "آخر فحص",
      addRow: "إضافة صف",
      relatedParty: "الطرف ذو العلاقة",
      relationship: "العلاقة",
      transactionType: "نوع المعاملة",
      amount: "المبلغ",
      fsHeadAccts: "بنود القوائم / الحسابات",
      identifiedBy: "تم التعرف من خلال",
      idBy_211a: "211(a)", idBy_gl: "فحص الأستاذ", idBy_minutes: "المحاضر",
      idBy_confirmation: "المصادقة", idBy_other: "أخرى",
      normalCourse: "ضمن السياق المعتاد للأعمال؟",
      yeBalance: "الرصيد في نهاية السنة",
      confirmationLink: "رابط المصادقة",
      disclosed: "مُفصح عنه؟",
      significant: "جوهري؟",
      outsideNormalCourse: "خارج السياق المعتاد للأعمال؟",
      requiredEvidenceTitle: "الأدلة المطلوبة (جوهري + خارج السياق المعتاد)",
      req_contract: "تم فحص العقد",
      req_rationale: "المبرر التجاري",
      req_terms: "اتساق الشروط مع تفسيرات الإدارة",
      req_accounting: "المعالجة المحاسبية مناسبة",
      req_authorised: "معتمد وموافَق عليه",
      armsLength: "على أساس تجاري بحت؟",
      armsLengthEvidence: "دليل الأساس التجاري",
      newlyIdentified: "طرف مُحدَّد حديثًا (غير مدرج في 211(a))",
      newlyChecklistTitle: "قائمة التحقق للأطراف المُحدَّدة حديثًا",
      new_team_informed: "إبلاغ الفريق",
      new_management_asked: "سؤال الإدارة عن كل المعاملات مع هذا الطرف",
      new_why_not: "لماذا لم يُتعرف عليه سابقًا؟",
      new_substantive: "تنفيذ الإجراءات الجوهرية",
      new_risk_reassessed: "إعادة تقييم الخطر",
      new_211a_updated: "تحديث 211(a)",
      sendToMisstatements: "إرسال إلى التحريفات",
      sentToMsOk: "تم الإرسال إلى التحريفات.",
      communicateTcwg: "تم إبلاغ المكلفين بالحوكمة",
      communicateTcwgDate: "تاريخ الإبلاغ",
      exception: "استثناء",
      exceptionNote: "ملاحظة الاستثناء",
      conclusion: "الاستنتاج",
      preparer: "المُعِد", reviewer: "المُراجِع",
      markComplete: "تعليم مكتمل",
      hitsFound: "نتائج الأستاذ",
      scanRunning: "جاري فحص الأستاذ…",
      scanResultOn: "نتيجة فحص الأستاذ في {date}",
      noGlEntriesFor: "لا توجد قيود في الأستاذ للطرف {party}.",
      entriesFound: "{count} قيد بالأستاذ · الإجمالي {total}",
      viewSent: "عرض القيد",
      reasons: {
        conclusion_missing: "الاستنتاج مطلوب.",
        preparer_missing: "توقيع المُعِد مطلوب.",
        reviewer_missing: "توقيع المُراجِع مطلوب.",
        exception_note_required: "الاستثناء يحتاج إلى ملاحظة.",
        significant_outside_normal_missing_evidence: "الصفوف الجوهرية والخارجة عن السياق المعتاد تحتاج جميع بنود الأدلة الخمسة.",
        arms_length_needs_evidence: "الصفوف التي تدّعي الأساس التجاري تحتاج إلى دليل داعم.",
        newly_identified_incomplete: "الصفوف المُحدَّدة حديثًا تحتاج إلى إكمال كل بنود قائمة التحقق.",
      },
    },
  },
};

export default I18N_BASE_RELATED_PARTIES;
